<template>
  <div class="product-tile">
    <div class="image-container">
      <img :src="product.image_url" :alt="product.name" class="product-image" />
    </div>
    <div class="product-info">
      <h3 class="product-name">{{ product.name }}</h3>
      <p v-if="product.description" class="product-description">{{ product.description }}</p>
      <table v-if="product.icerik" class="product-icerik">
        <tr v-for="(value, key) in product.icerik" :key="key">
          <td class="icerik-key">{{ key }}</td>
          <td class="icerik-value">{{ value }}</td>
        </tr>
      </table>
    </div>
    <div class="button-container">
      <button class="info-button" @click="openProjectUrl">{{ product.button_label || 'Ürünleri Görüntüle' }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryTile',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    openProjectUrl() {
      if (!this.product.project_url) return;

      if (this.product.project_url.startsWith('/')) {
        this.$router.push(this.product.project_url);
        return;
      }

      window.open(this.product.project_url, '_blank');
    }
  }
};
</script>

<style scoped>
.product-tile {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 300px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 10px;
  height: 100%;
  background: #ffffff;
}

.product-tile:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12);
}

.image-container {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: radial-gradient(140% 140% at 50% 20%, #ecfdf3, #ffffff);
}

.product-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-info {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  height: 100%;
}

.product-name {
  font-size: 18px;
  font-weight: 800;
  margin: 0;
  color: #0f172a;
}

.product-description {
  margin: 0;
  color: #334155;
  line-height: 1.5;
  font-size: 13px;
}

.product-icerik {
  width: 100%;
  border-collapse: collapse;
}

.product-icerik tr {
  border-bottom: 1px solid #e2e8f0;
}

.product-icerik .icerik-key {
  font-weight: 700;
  padding: 6px 6px 6px 0;
  color: #334155;
}

.product-icerik .icerik-value {
  padding: 6px 0;
  text-align: right;
  color: #0f172a;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 0 0 12px;
}

.info-button {
  background-color: #0f172a;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  padding: 10px 16px;
  border: 1px solid #0f172a;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.info-button:hover {
  background-color: #0b1221;
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.18);
}
</style>
